module.exports = "/_next/static/images/Whenever@2x-54d6e1f5c7a4fc4bfb22fc585da9ee98.png";